import { ChiptaElement, html, css } from 'chipta-libs/main.js';

class HrText extends ChiptaElement {

  render() {
    return html`
      <div class="line"></div>
      <div id="text"><slot></slot></div>
      <div class="line"></div>
    `;
  }

  static get styles() {

    return css`

      :host {
        display: flex;
        align-items: center;
      }

      .line { 
        height: 1px;
        background: #BBB;
        flex-grow: 1;
      }

      #text {
        margin: 0 5px;
      }

    `;

  }
}

customElements.define('hr-text', HrText);
